import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import { useDynamicContext, useDynamicEvents, useIsLoggedIn, useSwitchWallet,
    useUserWallets } from "@dynamic-labs/sdk-react-core";
import { verifyAccount } from '../services/account';
const defaultValue = {
    isLoggedIn: false,
    isConnecting: false,
    mvUser: null,
    verifyMvAccount: async () => {}
};
export const UserContext = createContext(defaultValue);
const UserContextProvider = ({ children }) => {
    const isDynamicLoggedIn = useIsLoggedIn();
    const { authToken, primaryWallet, handleLogOut, sdkHasLoaded } =
        useDynamicContext();
    const switchWallet = useSwitchWallet();
    const userWallets = useUserWallets();
    const isConnecting = useRef(true);
    const [ isLoggedIn, setIsLoggedIn ] = useState(false);
    const [ mvUser, setMvUser ] = useState(null);
// Login to Motorverse account once logged in to Dynamic
    useEffect(() => {
        const init = async () => {
            try {
                isConnecting.current = true;
                await verifyMvAccount();
                setIsLoggedIn(true);
            } catch(e) {
                console.error(e);
                await handleLogOut();
            } finally {
                isConnecting.current = false;
            }
        }
        if (sdkHasLoaded) {
            if (isDynamicLoggedIn && !mvUser) {
                init();
            } else {
                isConnecting.current = false;
            }
        }
    }, [ isDynamicLoggedIn, mvUser, sdkHasLoaded ])
// Set primary wallet if not set
    useEffect(() => {
        if (isDynamicLoggedIn && !primaryWallet && userWallets.length) {
            switchWallet(userWallets[0].id);
        }
    }, [primaryWallet, isDynamicLoggedIn, userWallets])
    useDynamicEvents("logout", () => {
        setIsLoggedIn(false);
        setMvUser(null);
        console.log("logout");
    })
    const verifyMvAccount = async () => {
        try {
            const result = await verifyAccount(authToken);
            setMvUser(result);
            return result;
        } catch (e) {
            throw new Error(e.message);
        }
    };
    return (
        <UserContext.Provider value={{
            isLoggedIn,
            isConnecting: isConnecting.current,
            mvUser,
            verifyMvAccount
        }}>
            {children}
        </UserContext.Provider>
    );
};
const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUser must be used within a UserContextProvider");
    }
    return context;
};
export { useUser, UserContextProvider };